export const CustomerCoSupportIcon = ({ height = '35', width = '35', className = '' }) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="35" height="35" rx="4" fill="#A498FF" />
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#05050D" strokeOpacity="0.05" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26 10.75C26 9.50736 24.9926 8.5 23.75 8.5L11.25 8.5C10.0074 8.5 9 9.50736 9 10.75L9 20.8106C9 22.0533 10.0074 23.0606 11.25 23.0606L15.2679 23.0606L17.5821 25.4998L19.8962 23.0606L23.75 23.0606C24.9926 23.0606 26 22.0533 26 20.8106L26 10.75Z"
        fill="#05050D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.8679 16.4766C23.3084 16.0342 23.3084 15.3168 22.8679 14.8744C22.4274 14.4319 21.7132 14.4319 21.2727 14.8744C20.8322 15.3168 20.8322 16.0342 21.2727 16.4766C21.7132 16.9191 22.4274 16.9191 22.8679 16.4766ZM18.1972 14.8747C18.6376 15.3172 18.6376 16.0348 18.1972 16.4774C17.7568 16.9199 17.0428 16.9199 16.6025 16.4774C16.1621 16.0348 16.1621 15.3172 16.6025 14.8747C17.0428 14.4321 17.7568 14.4321 18.1972 14.8747ZM13.7817 14.8742C14.222 15.3167 14.222 16.0343 13.7817 16.4769C13.3413 16.9194 12.6273 16.9194 12.1869 16.4769C11.7466 16.0343 11.7466 15.3167 12.1869 14.8742C12.6273 14.4316 13.3413 14.4316 13.7817 14.8742Z"
        fill="#A498FF"
      />
    </svg>
  );
};
